import { Component, ElementRef, Inject, OnDestroy, OnInit, Optional, TemplateRef, ViewChild } from '@angular/core';
import { ResourceImage } from './media.models';
import { Subject, takeUntil } from 'rxjs';
import { VlHttpService, VlDataService, HTTPAPIConfig, APIConfigMapping, APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from 'shared-library';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'lib-media',
  templateUrl: './media.component.html',
  styleUrl: './media.component.scss'
})
export class MediaComponent implements OnInit,OnDestroy {

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;
   @ViewChild('imageDetailsPopUp') imageDetailsPopUp!: TemplateRef<any>;
   @ViewChild('deleteDialog') deleteDialog!: TemplateRef<any>;
   @ViewChild('replaceDialog') replaceDialog!: TemplateRef<any>;
   @ViewChild('forceConformation') forceConformation!: TemplateRef<any>;
   @ViewChild('deleteForceConformation') deleteForceConformation!: TemplateRef<any>;

  images: ResourceImage[] = [];
  spinnerActive:boolean = false;
  loadingMap: { [key: string]: boolean } = {};


  instanceTypes :{
    popUp:string,
    store:string
  } = {
    popUp:'popup',
    store:'store'
  }
  currentInstanse:string = '';
  conflicts:any;
  searchText:string ='';
  filteredImages: ResourceImage[] = [...this.images];
  selectedImage: ResourceImage | null = null;
  destroy$:Subject<void> = new Subject<void>();
  isReplaceMode:boolean = false;
  replaceFile:any;
  replaceDialogref:any;
  queryParams:any = {};
  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  constructor(  private httpService: VlHttpService, private route: ActivatedRoute,
      private dataService: VlDataService, public dialog: MatDialog,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
      @Optional() public dialogRef: MatDialogRef<MediaComponent>,private toastrService:ToastrService){

  }

  async ngOnInit() {
    this.routeSubscritions();
    await this.getResourse();
    if(this.data){
      this.currentInstanse = this.instanceTypes.popUp;
      if(this.data.blobName){
        let resource = this.images.find((resource:ResourceImage) => resource.resource_url === this.data.blobName);
        if(resource){
          this.onSelectImage(resource);
        }
      }else{
        let resource = this.images.find((resource:ResourceImage) => resource.resource_url === this.data.image.split('?')[0]);
        if(resource){
          this.onSelectImage(resource);
        }
      }
      this.images.forEach(img => this.loadingMap[img.resource_id] = true);
    }else{
      this.currentInstanse = this.instanceTypes.store
    }
  }

  routeSubscritions(){
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
          this.queryParams = {};
          for (const param in params) {
            if (params.hasOwnProperty(param)) {
              this.queryParams[param] = params[param];
            }
          }
        });
  }

  onLoad(img: string) {
    this.loadingMap[img] = false;
  }
  
 
  async getResourse(){
     const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_MEDIA_IMAGES']);
        apiConfig.postData = {
          "application_id":this.queryParams['id'],
        }
        this.spinnerActive = true;
       await this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: (response: any) => {
            
            this.images = response.result;
            this.filteredImages = [...this.images];
            this.searchText = '';
            if(this.currentInstanse === this.instanceTypes.popUp && this.data){
              let resource = this.filteredImages.find((resource:ResourceImage) => resource.resource_url === this.data.image);
              if(resource){
                this.onSelectImage(resource);
              }
            }
          },
          complete: () => {
            this.spinnerActive = false;
          },
          error: (err: any) => {
            this.spinnerActive = false;
            if(err.status === 403){
              this.toastrService.error( "You don't have the necessary permissions  in User Management for the resource resourceImage.")
            }else{
              this.toastrService.error(err.error.error ?? 'Failed to fetch resource.')
            }
          }
        });
  }

 

  onSearch(searchEvent: any): void {
    this.filteredImages.forEach((image) => image.selected = false)
    let searchText = searchEvent.target.value.toLowerCase().trim();
    this.filteredImages = this.images.filter(img =>
      img.resource_name.toLowerCase().includes(searchText)
    );
    if (this.selectedImage && !this.filteredImages.some(i => i.resource_id === this.selectedImage?.resource_id)) {
      this.selectedImage = null;
    }
  }

  onPickImage(image:ResourceImage){
    this.dialogRef.close({proceed:true,image:image});
  }

  onUploadClick(): void {
    this.isReplaceMode = false;
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      if (this.isReplaceMode && this.selectedImage) {
         // Replace operation: update the selected image properties
        this.replaceFile = file;
        this.replaceResourcedialog(this.dialogRef);        
      } else {
       
       this.uploadImage( e.target.result,file);
      }
    };
    reader.readAsDataURL(file);
    input.value = '';
  }

  replaceImage(file:any,isForce:boolean,dialogRef?:any){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['REPLACE_MEDIA_IMAGE']);
        apiConfig.postData = {
          "applicationId":this.queryParams['id'],
          "resource_id":this.selectedImage?.resource_id,
          "force_update":isForce,
          "resource_url":this.selectedImage?.resource_url,
          "resource_blob":this.selectedImage?.resource_blob,
          "resource":file,
        }
       
        this.spinnerActive = true;
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: (response: any) => {
          

            this.selectedImage = response.resource;
          },
          complete: () => {
            this.getResourse();
          
            if(dialogRef && this.currentInstanse === this.instanceTypes.store){
              dialogRef.close({proceed:false,force:false})
            }
            this.spinnerActive = false;

          },
          error: (err: any) => {
            if(err.status === 403){
              this.toastrService.error( "You don't have the necessary permissions  in User Management for the resource resourceImage.")
            }else if(err.status === 409){
            this.openChangeForceConformationPopUp(this.forceConformation,err.error,'replace')
          }else{
          this.toastrService.error(err.error.error)
          }
          this.spinnerActive = false;
        }
        });
  }

  deleteResourcedialog(dialogRef?:any){
    if (this.conflicts && this.conflicts.count > 0) {
      this.openChangeForceConformationPopUp(this.deleteForceConformation, this.conflicts, "delete",dialogRef);
    } else {
      this.openDeleteDialog(dialogRef);
    }
 }

 replaceResourcedialog(dialogRef:any){
  if (this.conflicts && this.conflicts.count > 0) {
    this.openChangeForceConformationPopUp(this.forceConformation, this.conflicts, "replace",dialogRef);
  } else {
    this.openReplaceDialog(dialogRef);
  }
}

  openChangeForceConformationPopUp(template:TemplateRef<any>,links:any,type:string,dialogref?:any){
    const dialogRef = this.dialog.open(template,{
      data:links,
      maxWidth: '60vw',
    })

    this.conflicts = links;

    dialogRef.afterClosed().subscribe(result => {
      if (result.proceed) {
        // Perform replace action here
        if(type === 'replace'){
          this.replaceImage(this.replaceFile,result.force,dialogref)
        }else if(type === 'delete' && this.selectedImage){
          this.deleteImage(this.selectedImage,result.force,dialogref)
        }
      }
    });
  }

  get formattedMessage(): string {
    const pageList = this.conflicts.pages
    .map((page:any) => `"${page.pageName}"`)
    .join(', ');
      const resourceName = `<b>${this.selectedImage?.resource_name}</b>`;
      const pageListHtml = `<b>${pageList}</b>`;
      const pageCount = this.conflicts.pages.length;
      const plural = pageCount > 1 ? 's' : '';
    
      return `The image ${resourceName} is currently used on ${pageCount} page${plural}: ${pageListHtml}.<br>Deleting it will remove it from all linked page${plural}.`;
  }

  get formattedReplaceMessage(): string {
    const pageList = this.conflicts.pages
    .map((page:any) => `"${page.pageName}"`)
    .join(', ');
      const resourceName = `<b>${this.selectedImage?.resource_name}</b>`;
      const pageListHtml = `<b>${pageList}</b>`;
      const pageCount = this.conflicts.pages.length;
      const plural = pageCount > 1 ? 's' : '';
    
      return `The image ${resourceName} is currently used on ${pageCount} page${plural}: ${pageListHtml}.<br>Replacing it will update the image on all linked page${this.conflicts.pages.length > 1 ? 's' : ''}.`;
  }

  uploadImage(imageFile:any,file:any){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPLOAD_MEDIA_IMAGE']);
        apiConfig.postData = {
          "applicationId":this.queryParams['id'],
          "resource":file
        }
        this.spinnerActive = true;
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: (response: any) => {
            this.images = [response.resource,...this.images];
            this.filteredImages = [...this.images];
            this.searchText = '';
          },
          complete: () => {
            this.getResourse();
            // this.spinnerActive = false;
          },
          error: (err: any) => {
            this.spinnerActive = false;
            if(err.status === 403){
              this.toastrService.error( "You don't have the necessary permissions  in User Management for the resource resourceImage.")
            }else{
           this.toastrService.error(err.error);
            }
          }
        });
  }

  onSelectImage(image: ResourceImage): void {
    this.images.forEach(img => img.selected = false);
    image.selected = true;
    this.selectedImage = image;
    if(this.currentInstanse === this.instanceTypes.store){
      this.openModel();
    };
    this.conflicts = null;
    this.checkResourceLinks()
  }

  directSelect(image:ResourceImage){
    this.onPickImage(image);
  }

  onClearSelection(): void {
    this.images.forEach(img => img.selected = false);
    this.selectedImage = null;
  }

  onReplaceImage(dialogRef?:any): void {
    if (!this.selectedImage) return;
    this.isReplaceMode = true;
    // You can differentiate the replace logic here if needed.
    this.fileInput.nativeElement.click();
    this.replaceDialogref = dialogRef ?? {};
  }

  openModel(){
    const dialogRef = this.dialog.open(this.imageDetailsPopUp, {
      width: '60vw',
    });
    
    dialogRef.afterClosed().subscribe(result => {
       this.onClearSelection();
    });
  }
  
  checkResourceLinks(){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CHECK_REPLACE_MEDIA_LINKS']);
    apiConfig.postData = {
      "applicationId":this.queryParams['id'],
      "resource_id":this.selectedImage?.resource_id,
      "resource_url":this.selectedImage?.resource_url,
    }
   

    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: any) => {
        this.conflicts = response.data;
        this.searchText = '';
      },
      complete: () => {
      },
      error: (err: any) => {

      this.conflicts = null;
      if(err.status === 403){
        this.toastrService.error( "You don't have the necessary permissions  in User Management for the resource resourceImage.")
      }else{
      this.toastrService.error(err.error.error ?? "Failed to check resourse links");
      }
    }
    });
  }

  onDeleteImage(): void {
    if (!this.selectedImage) return;
    this.images = this.images.filter(img => img.resource_id !== this.selectedImage?.resource_id);
    this.filteredImages = this.filteredImages.filter(img => img.resource_id !== this.selectedImage?.resource_id);
    this.selectedImage = null;
  }

  deleteImage(image:ResourceImage,force:boolean,dialogRef?:any){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_MEDIA_IMAGE']);
        apiConfig.postData = {
          "applicationId":this.queryParams['id'],
          "resource_id":image?.resource_id,
          "force_delete":force,
          "resource_url":image?.resource_url,
        }
       
        this.spinnerActive = true;
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: (response: any) => {
            this.images = response.result;
            this.filteredImages = [...this.images];
            this.toastrService.success(response.message)
          },
          complete: () => {
            // this.selectedImage = null
            if(dialogRef && this.currentInstanse === this.instanceTypes.store){
              dialogRef.close({proceed:true});
            }
            this.getResourse();
            this.spinnerActive = false;
          },
          error: (err: any) => {
            if(err.status === 403){
              this.toastrService.error( "You don't have the necessary permissions  in User Management for the resource resourceImage.")
            }else if(err.status === 409){
              this.openChangeForceConformationPopUp(this.forceConformation,err.error,'delete')
            }else{
            this.toastrService.error(err.error.error)
            }
            this.spinnerActive = false;
          }
        });
  }


  // delete and replace 
  openDeleteDialog(detailsref?:any): void {
    const dialogRef = this.dialog.open(this.deleteDialog,{
      maxWidth: '60vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.proceed) {
        if(this.selectedImage){
          this.deleteImage(this.selectedImage,result?.force,detailsref);
        }
        // Perform delete action here
      }
    });
  }

  openReplaceDialog(detailsref?:any): void {
    this.isReplaceMode = true;
    const dialogRef = this.dialog.open(this.replaceDialog,{
      maxWidth: '60vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.proceed) {
        // Perform replace action here
        this.replaceImage(this.replaceFile,result.force,dialogRef)
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
